/**
 * TDN – předvolba délky lana z URL parametru ?dl=<metry>
 *
 * Průvodce výběrem lana (sections/tdn-r-rope-wizard.liquid) posílá na PDP odkazy
 * ve tvaru /products/<handle>?dl=70. Tento skript po vykreslení variant pickeru
 * doklikne odpovídající hodnotu optionu „Délka lana (m)“ nativní cestou –
 * stejným 'change' eventem, jaký vyvolá klik uživatele – takže se přepočítá cena,
 * dostupnost, tlačítko do košíku i URL (?variant=).
 *
 * Chová se defenzivně: cokoli nesedí → tiše skončí, bez chyby v konzoli.
 * - chybí ?dl nebo to není číslo         → nic
 * - v URL je explicitní ?variant=        → nic (explicitní volba má přednost)
 * - option „Délka…“ na produktu není     → nic
 * - daná délka u produktu / u vybrané barvy neexistuje → nic
 * - uživatel mezitím sám klikl           → nic
 *
 * Barvu nikdy nemění – vybírá výhradně délku.
 *
 * Závislost: assets/variant-picker.js (custom element <variant-picker>).
 * Zapojeno pouze v sections/tdn-r-main-product.liquid (defer).
 */
(function () {
  'use strict';

  var PARAM = 'dl';
  var POLL_MS = 50;
  var MAX_WAIT_MS = 4000;
  // Prvky, u kterých bereme trusted event jako „uživatel si vybral sám“.
  var USER_SCOPE = 'variant-picker, .option-selector, .js-product-form, custom-select';

  if (window.__tdnDlPreselectLoaded) return;
  window.__tdnDlPreselectLoaded = true;

  var userActed = false;
  var userEvents = ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'change'];

  function onUserEvent(evt) {
    try {
      if (!evt || evt.isTrusted !== true) return;
      var target = evt.target;
      if (!target || typeof target.closest !== 'function') return;
      if (target.closest(USER_SCOPE)) userActed = true;
    } catch (e) {
      /* noop */
    }
  }

  function addUserListeners() {
    userEvents.forEach(function (type) {
      document.addEventListener(type, onUserEvent, { capture: true, passive: true });
    });
  }

  function removeUserListeners() {
    userEvents.forEach(function (type) {
      document.removeEventListener(type, onUserEvent, { capture: true });
    });
  }

  /**
   * Přísný převod parametru z URL na číslo. "70", " 70 ", "70,5" → číslo; "abc", "70m" → null.
   * @param {string} value Hodnota z URL.
   * @returns {?number} Číslo, nebo null.
   */
  function parseParamNumber(value) {
    if (typeof value !== 'string') return null;
    var s = value.trim().replace(',', '.');
    if (!/^\d+(?:\.\d+)?$/.test(s)) return null;
    var n = parseFloat(s);
    return isFinite(n) && n > 0 ? n : null;
  }

  /**
   * Benevolentní převod hodnoty optionu na číslo ("60", "60 m", "60,0" → 60).
   * @param {string} value Hodnota optionu.
   * @returns {?number} Číslo, nebo null.
   */
  function parseOptionNumber(value) {
    if (value === null || value === undefined) return null;
    var m = String(value).replace(',', '.').match(/\d+(?:\.\d+)?/);
    if (!m) return null;
    var n = parseFloat(m[0]);
    return isFinite(n) ? n : null;
  }

  function sameNumber(a, b) {
    return a !== null && b !== null && Math.abs(a - b) < 1e-9;
  }

  /**
   * Odolné porovnání názvu optionu – bez diakritiky, lowercase.
   * @param {string} name Název optionu, např. "Délka lana (m)".
   * @returns {boolean} True pro délkový option.
   */
  function isLengthOption(name) {
    if (!name) return false;
    var s = String(name);
    if (typeof s.normalize === 'function') {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    s = s.toLowerCase();
    return s.indexOf('delka') !== -1 || s.indexOf('length') !== -1;
  }

  /**
   * Hlavní variant picker produktu (ne quick-buy, ne featured product).
   * @returns {?Element} Element <variant-picker>, nebo null.
   */
  function findPicker() {
    var pickers = document.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i += 1) {
      var el = pickers[i];
      if (el.closest('.js-quickbuy') || el.closest('.cc-featured-product')) continue;
      if (!el.closest('.js-product')) continue;
      return el;
    }
    return null;
  }

  /**
   * Najde selector optionu s délkou.
   * @param {Element} picker Element <variant-picker>.
   * @returns {?Element} .option-selector délky, nebo null.
   */
  function findLengthSelector(picker) {
    var selectors = picker.querySelectorAll('.option-selector:not(.option-selector--custom)');
    for (var i = 0; i < selectors.length; i += 1) {
      if (isLengthOption(selectors[i].getAttribute('data-option'))) return selectors[i];
    }
    return null;
  }

  /** Varianta pro danou hodnotu existuje jen tehdy, když Liquid vyplnil data-variant-id. */
  function isSelectable(el) {
    if (!el) return false;
    if (el.hidden || el.disabled) return false;
    return !!el.getAttribute('data-variant-id');
  }

  /**
   * Radio buttony (výchozí styl "buttons").
   * @param {Element} selector .option-selector.
   * @param {number} target Požadovaná délka.
   */
  function applyListed(selector, target) {
    var inputs = selector.querySelectorAll('input.js-option[type="radio"]');
    var match = null;
    for (var i = 0; i < inputs.length; i += 1) {
      if (sameNumber(parseOptionNumber(inputs[i].value), target)) {
        match = inputs[i];
        break;
      }
    }
    if (!match || match.checked || !isSelectable(match)) return;
    if (userActed) return;

    match.checked = true;
    match.dispatchEvent(
      new CustomEvent('change', { bubbles: true, cancelable: false, detail: { noFocus: true } })
    );
  }

  /**
   * Dropdown (<custom-select>) – pro případ, že se styl selectoru přepne v nastavení bloku.
   * @param {Element} selector .option-selector.
   * @param {number} target Požadovaná délka.
   */
  function applyDropdown(selector, target) {
    var options = selector.querySelectorAll('.custom-select__option.js-option');
    var match = null;
    for (var i = 0; i < options.length; i += 1) {
      var value = options[i].dataset ? options[i].dataset.value : null;
      if (!value) continue;
      if (sameNumber(parseOptionNumber(value), target)) {
        match = options[i];
        break;
      }
    }
    if (!match || match.getAttribute('aria-selected') === 'true' || !isSelectable(match)) return;

    var customSelect = match.closest('custom-select');
    if (!customSelect || typeof customSelect.selectOption !== 'function') return;
    if (userActed) return;

    // Stejná cesta jako klik uživatele, jen bez přesunu fokusu.
    customSelect.addEventListener('change', function (evt) {
      if (evt && evt.detail) evt.detail.noFocus = true;
    }, { once: true });
    customSelect.selectOption(match);
  }

  /**
   * @param {Element} picker Element <variant-picker>.
   * @param {number} target Požadovaná délka.
   */
  function apply(picker, target) {
    if (userActed) return;
    var selector = findLengthSelector(picker);
    if (!selector) return;

    if (selector.dataset && selector.dataset.selectorType === 'dropdown') {
      applyDropdown(selector, target);
    } else {
      applyListed(selector, target);
    }
  }

  /**
   * Počká, než se <variant-picker> upgraduje (atribut "loaded" nastaví jeho konstruktor)
   * a než doběhne jeho vlastní applySearchParams (setTimeout 0 v konstruktoru).
   * @param {number} target Požadovaná délka.
   */
  function whenPickerReady(target) {
    var started = Date.now();

    function tick() {
      if (userActed) {
        removeUserListeners();
        return;
      }
      var picker = null;
      try {
        picker = findPicker();
      } catch (e) {
        removeUserListeners();
        return;
      }

      if (picker && picker.hasAttribute('loaded')) {
        window.setTimeout(function () {
          try {
            apply(picker, target);
          } catch (e) {
            /* tiše */
          }
          removeUserListeners();
        }, 0);
        return;
      }

      if (Date.now() - started > MAX_WAIT_MS) {
        removeUserListeners();
        return;
      }
      window.setTimeout(tick, POLL_MS);
    }

    tick();
  }

  function init() {
    var target;
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has(PARAM)) return;
      if (params.has('variant')) return;
      target = parseParamNumber(params.get(PARAM));
    } catch (e) {
      return;
    }
    if (target === null) return;

    addUserListeners();
    whenPickerReady(target);
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  } catch (e) {
    /* tiše */
  }
}());
